import { render, staticRenderFns } from "./CardSetting.vue?vue&type=template&id=46700adb&"
import script from "./CardSetting.vue?vue&type=script&lang=js&"
export * from "./CardSetting.vue?vue&type=script&lang=js&"
import style0 from "./CardSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports